// LineaRowXL - Sprint 44 Fase 3 Vista 4.
// Fila individual de linea comercial (venta/cotizacion). Extraida de
// LineasPanelXL para respetar la regla de <300 lineas por archivo.
// Usa XLMoneyInput para precio, XLSelect para IVA y un input numeric
// tokenizado para cantidad y descuento.
import XLMoneyInput from '../xl/XLMoneyInput';
import XLSelect from '../xl/XLSelect';
import { fmtMoney } from '../../utils/money';

const IVA_OPCIONES = [
  { value: 0,  label: '0% (exento)' },
  { value: 5,  label: '5%' },
  { value: 19, label: '19%' },
];

export default function LineaRowXL({
  linea, isEditable, moneda,
  onEditField, onDelete,
}) {
  const l = linea;
  return (
    <tr>
      <td>{l.producto_descripcion || ('Producto #' + (l.producto_id || ''))}</td>
      <td className="xl-td-right">
        <input
          type="number"
          className="xl-lineas__numinp"
          disabled={!isEditable}
          defaultValue={l.cantidad}
          onBlur={(e) => onEditField(l, 'cantidad', Number(e.target.value))}
        />
      </td>
      <td className="xl-td-right">
        <XLMoneyInput
          value={l.precio_unitario}
          onChange={(n) => onEditField(l, 'precio_unitario', n)}
          disabled={!isEditable}
        />
      </td>
      <td className="xl-td-right">
        <input
          type="number"
          className="xl-lineas__numinp"
          style={{ width: '64px' }}
          disabled={!isEditable}
          defaultValue={l.descuento}
          onBlur={(e) => onEditField(l, 'descuento', Number(e.target.value))}
        />
      </td>
      <td className="xl-td-right">
        <XLSelect
          value={l.iva_pct == null ? 19 : l.iva_pct}
          onChange={(e) => onEditField(l, 'iva_pct', Number(e.target.value))}
          options={IVA_OPCIONES}
          disabled={!isEditable}
        />
      </td>
      <td className="xl-td-right xl-lineas__mono">{fmtMoney(l.base_linea, moneda)}</td>
      <td className="xl-td-right xl-lineas__mono">{fmtMoney(l.iva_linea, moneda)}</td>
      <td className="xl-td-right xl-lineas__mono">{fmtMoney(l.total_linea, moneda)}</td>
      <td className="xl-td-right">
        {isEditable && (
          <button
            type="button"
            className="xl-lineas__del"
            onClick={() => onDelete(l)}
            aria-label="Eliminar linea"
          >
            X
          </button>
        )}
      </td>
    </tr>
  );
}
